export const capitalizeFirstChar = (str) => {
    if (!str)
        return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export const isActiveNow = (timeRange, timeZone = "Asia/Kolkata") => {
    var _a, _b;
    if (!timeRange)
        return false;
    try {
        new Intl.DateTimeFormat("en-US", { timeZone });
    }
    catch (e) {
        console.warn(`Invalid timezone "${timeZone}", falling back to Asia/Kolkata`);
        timeZone = "Asia/Kolkata";
    }
    const [startStr, endStr] = timeRange.split(" - ");
    const [startHour, startMinute] = startStr.split(":").map(Number);
    const [endHour, endMinute] = endStr.split(":").map(Number);
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone,
    });
    const parts = formatter.formatToParts(now);
    const currentHour = parseInt(((_a = parts.find((p) => p.type === "hour")) === null || _a === void 0 ? void 0 : _a.value) || "0");
    const currentMinute = parseInt(((_b = parts.find((p) => p.type === "minute")) === null || _b === void 0 ? void 0 : _b.value) || "0");
    const currentTotalMinutes = currentHour * 60 + currentMinute;
    const startTotalMinutes = startHour * 60 + startMinute;
    const endTotalMinutes = endHour * 60 + endMinute;
    if (startTotalMinutes <= endTotalMinutes) {
        return (currentTotalMinutes >= startTotalMinutes &&
            currentTotalMinutes <= endTotalMinutes);
    }
    else {
        return (currentTotalMinutes >= startTotalMinutes ||
            currentTotalMinutes <= endTotalMinutes);
    }
};
export const isLightColor = (color) => {
    if (!color)
        return false;
    const hexToRgb = (hex) => {
        hex = hex.replace(/^#/, "");
        if (hex.length === 3) {
            hex = hex
                .split("")
                .map((char) => char + char)
                .join("");
        }
        const bigint = parseInt(hex, 16);
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    };
    const [r, g, b] = hexToRgb(color);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5;
};
export const formatPartnerType = (input) => {
    var _a, _b;
    return (_b = (_a = input === null || input === void 0 ? void 0 : input.split("-")) === null || _a === void 0 ? void 0 : _a.map((word) => word.charAt(0).toUpperCase() + word.slice(1))) === null || _b === void 0 ? void 0 : _b.join(" ");
};
export const formatFileName = (name) => {
    var _a;
    if (!name)
        return "";
    const formatted = (_a = name === null || name === void 0 ? void 0 : name.toLowerCase()) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, "_");
    return encodeURIComponent(formatted);
};
